import { red, teal } from '@mui/material/colors';
import Slider, { SliderThumb } from '@mui/material/Slider';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import VoteButton from './VoteButton';

const downVoteTheme = createTheme({
  palette: {
    primary: red,
  },
});

const upVoteTheme = createTheme({
  palette: {
    primary: teal,
  },
});

const StyledSlider = withStyles(
  Slider,
  {
    thumb: {
      ':before': {
        display: 'none',
      },
    },
  },
  { name: 'StyledSlider' },
);

function ValueLabelComponent(props) {
  const { children, open, value } = props;

  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
};

class EmojiSlider extends Component {
  EmojiThumbComponent = props => {
    const { children, ...other } = props;
    return (
      <SliderThumb {...other}>
        {children}
        <span className={this.props.loading ? 'tw-animate-spin' : undefined}>
          <VoteButton
            weight={
              this.props.curatorValues && this.props.weight > 0
                ? this.props.weight / 10
                : this.props.weight
            }
            size="35"
          />
        </span>
      </SliderThumb>
    );
  };

  render() {
    const { weight, setWeight, onChangeCommitted } = this.props;

    return (
      <>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={weight < 0 ? downVoteTheme : upVoteTheme}>
            <StyledSlider
              slots={{
                valueLabel: ValueLabelComponent,
                thumb: this.EmojiThumbComponent,
              }}
              track={false}
              valueLabelFormat={x => {
                let number = x;
                if (number > -0.5 && number < 0) number = -1;
                else if (number >= 0 && number < 0.5) number = 1;
                number = Math.round(number);
                return x >= 0 ? `+${number}` : number;
              }}
              value={weight}
              min={-10}
              max={this.props.curatorValues ? 100 : 10}
              step={0.001}
              onChange={setWeight}
              onChangeCommitted={onChangeCommitted}
              valueLabelDisplay="auto"
            />
          </ThemeProvider>
        </StyledEngineProvider>
      </>
    );
  }
}

export default EmojiSlider;
